// GÉNÉRÉ par scripts/build-place-slugs.mjs — ne pas éditer à la main.
// Source de vérité : src/data/places.js (21 fiches).
// Consommé par le méga-menu (src/components/nav/MegaMenu.jsx) pour ranger
// les lieux en colonnes sans recopier une seule fois leur liste.
export const PLACES_NAV = [
  {
    "slug": "parque-urraca",
    "types": [
      "Park",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Parque Urracá",
      "en": "Parque Urracá",
      "es": "Parque Urracá"
    }
  },
  {
    "slug": "cinta-costera",
    "types": [
      "Park",
      "TouristAttraction",
      "LandmarksOrHistoricalBuildings"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Cinta Costera",
      "en": "Cinta Costera",
      "es": "Cinta Costera"
    }
  },
  {
    "slug": "pont-urraca-cinta",
    "types": [
      "LandmarksOrHistoricalBuildings",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Pont piéton Urracá ↔ Cinta Costera",
      "en": "Urracá ↔ Cinta Costera Footbridge",
      "es": "Puente peatonal Urracá ↔ Cinta Costera"
    }
  },
  {
    "slug": "casco-viejo",
    "types": [
      "HistoricalLandmark",
      "TouristAttraction",
      "Place"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Casco Viejo (San Felipe)",
      "en": "Casco Viejo (San Felipe)",
      "es": "Casco Viejo (San Felipe)"
    }
  },
  {
    "slug": "mercado-de-mariscos",
    "types": [
      "FoodEstablishment",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Mercado de Mariscos",
      "en": "Mercado de Mariscos",
      "es": "Mercado de Mariscos"
    }
  },
  {
    "slug": "bella-vista",
    "types": [
      "Neighborhood",
      "Place"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Bella Vista",
      "en": "Bella Vista",
      "es": "Bella Vista"
    }
  },
  {
    "slug": "punta-paitilla",
    "types": [
      "Neighborhood",
      "Place"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Punta Paitilla",
      "en": "Punta Paitilla",
      "es": "Punta Paitilla"
    }
  },
  {
    "slug": "albrook-mall",
    "types": [
      "ShoppingCenter",
      "BusStation",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Albrook Mall",
      "en": "Albrook Mall",
      "es": "Albrook Mall"
    }
  },
  {
    "slug": "amador-causeway",
    "types": [
      "TouristAttraction",
      "Beach",
      "Park"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Calzada de Amador (Amador Causeway)",
      "en": "Calzada de Amador (Amador Causeway)",
      "es": "Calzada de Amador (Amador Causeway)"
    }
  },
  {
    "slug": "costa-del-este",
    "types": [
      "Neighborhood",
      "Place"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Costa del Este",
      "en": "Costa del Este",
      "es": "Costa del Este"
    }
  },
  {
    "slug": "casinos-bella-vista",
    "types": [
      "EntertainmentBusiness",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Casinos & nightlife Bella Vista",
      "en": "Casinos & nightlife Bella Vista",
      "es": "Casinos y vida nocturna Bella Vista"
    }
  },
  {
    "slug": "miraflores-locks",
    "types": [
      "TouristAttraction",
      "LandmarksOrHistoricalBuildings"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Esclusas de Miraflores",
      "en": "Miraflores Locks",
      "es": "Esclusas de Miraflores"
    }
  },
  {
    "slug": "panama-viejo",
    "types": [
      "LandmarksOrHistoricalBuildings",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Panamá Viejo (ruines)",
      "en": "Panamá Viejo (ruins)",
      "es": "Panamá Viejo (ruinas)"
    }
  },
  {
    "slug": "parque-metropolitano",
    "types": [
      "Park",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Parque Natural Metropolitano",
      "en": "Parque Natural Metropolitano",
      "es": "Parque Natural Metropolitano"
    }
  },
  {
    "slug": "taboga-island",
    "types": [
      "Beach",
      "TouristAttraction",
      "Place"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Isla Taboga",
      "en": "Isla Taboga",
      "es": "Isla Taboga"
    }
  },
  {
    "slug": "cerro-ancon",
    "types": [
      "LandmarksOrHistoricalBuildings",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Cerro Ancón",
      "en": "Cerro Ancón",
      "es": "Cerro Ancón"
    }
  },
  {
    "slug": "parque-soberania",
    "types": [
      "Park",
      "TouristAttraction"
    ],
    "region": "Panamá",
    "title": {
      "fr": "Parque Nacional Soberanía",
      "en": "Parque Nacional Soberanía",
      "es": "Parque Nacional Soberanía"
    }
  },
  {
    "slug": "bocas-del-toro",
    "types": [
      "TouristAttraction",
      "Beach",
      "Place"
    ],
    "region": "Bocas del Toro",
    "title": {
      "fr": "Bocas del Toro",
      "en": "Bocas del Toro",
      "es": "Bocas del Toro"
    }
  },
  {
    "slug": "boquete",
    "types": [
      "TouristAttraction",
      "Place"
    ],
    "region": "Chiriquí",
    "title": {
      "fr": "Boquete",
      "en": "Boquete",
      "es": "Boquete"
    }
  },
  {
    "slug": "el-valle-de-anton",
    "types": [
      "TouristAttraction",
      "Place"
    ],
    "region": "Coclé",
    "title": {
      "fr": "El Valle de Antón",
      "en": "El Valle de Antón",
      "es": "El Valle de Antón"
    }
  },
  {
    "slug": "pedasi",
    "types": [
      "TouristAttraction",
      "Beach",
      "Place"
    ],
    "region": "Los Santos",
    "title": {
      "fr": "Pedasí",
      "en": "Pedasí",
      "es": "Pedasí"
    }
  }
];
